/** Meldungstexte von `Recalc()` in `IwmViewBestellposition.razor`. */

import type { OrderPosition } from '@/types/entities';

/** Ersatzwerte für Felder ohne Leseberechtigung — Zeichenlängen wie im Altclient. */
const PLACEHOLDER_YEAR = 'XXXX';
const PLACEHOLDER_NUMBER = 'XXXXXX';
const PLACEHOLDER_TEXT = 'XXXXXXXXXXXXX';

export const RECALC_CAPTION = 'Newberechnung';
export const RECALC_RUNNING = 'Aktualisiere...';
export const RECALC_NO_CONTAINER = 'Die Positionen hat keinen Container zugewiesen';
export const RECALC_FAILED_CAPTION = 'Newberechnung fehlgeschlagen';
export const RECALC_FAILED =
  'Es ist ein Fehler aufgetreten. Bitte prüfen Sie, ob dieser Bestellung Receipts zugewiesen wurden.';

export function buildRecalcSuccessText(model: OrderPosition): string {
  const belegjahr = model.Belegjahr ?? PLACEHOLDER_YEAR;
  const belegnummer = model.Belegnummer ?? PLACEHOLDER_NUMBER;
  const artikelnummer = model.Artikelnummer ?? PLACEHOLDER_NUMBER;
  const bezeichnung = model.Bezeichnung1 ?? PLACEHOLDER_TEXT;
  return `Die Frachtkosten für die Bestellung ${belegjahr}-${belegnummer} ${artikelnummer} ${bezeichnung} wurden erfolgreich aktualisiert.`;
}
